module.exports = __webpack_public_path__ + "img/209.df3a45b7.jpg";